import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";
import { shouldDetectSessionInUrl } from "@/lib/authCallbackUrl";

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SB_PUBLISHABLE_KEY,
      { auth: { detectSessionInUrl: shouldDetectSessionInUrl } },
    );
  }
  return supabaseClient;
};
